<div class="agpr-fileDownloads">
    <div class="agpr-fileDownloads-content">
        <h1 class="agpr-fileDownloads-header agpr-headerH1-light">{{ 'FileDownloads.header' | localize }}</h1>
        <agpr-table
            *ngIf="files.length > 0"
            id="existingFilesTable"
            class="agpr-fileDownloads-table"
            [columns]="columnDefs"
            [showDelete]="true"
            [enableSelectAll]="false"
            [(ngModel)]="files"
            (itemDelete)="deleteFile($event)"
        ></agpr-table>
        <agpr-message
            *ngIf="files.length === 0"
            [severity]="messageSeverities.noContent"
        >
            {{ 'FileDownloads.noContentMessage' | localize }}
        </agpr-message>
    </div>
</div>

<ng-template
    #statusCell
    let-row="row"
    let-column="column"
>
    <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
    <span
        [attr.role]="row.status === fileState.READY_TO_DOWNLOAD ? 'button' : 'img'"
        class="agpr-fileDownloads-statusIcon"
        [ngClass]="row.statusStyleClass"
        [agprTooltip]="row.statusTooltipText"
        tooltipPosition="top"
        [initiallyFocusable]="false"
        (keydown)="downloadFile(row.mediaId, $event)"
        (click)="downloadFile(row.mediaId)"
    ></span>
    <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
</ng-template>